import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCar = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.8,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M5 17H3v-4l2-5h11l3 5h2v4h-2" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 7.5,
			cy: 17.5,
			r: 1.7
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 16.5,
			cy: 17.5,
			r: 1.7
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 9.2,
			y1: 17.5,
			x2: 14.8,
			y2: 17.5
		})
	]
});
export default SvgCar;
